var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEthBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.556,
    height: 14,
    viewBox: "0 0 8.556 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eth",
    transform: "translate(-0.418 -0.667)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M16.1.667,16.01.986v9.257l.093.094L20.379,7.8Z",
    transform: "translate(-11.409)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M4.694.667.418,7.8l4.277,2.54V.667Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M16.214,32.677l-.053.064v3.3l.053.155,4.279-6.055Z",
    transform: "translate(-11.52 -21.526)",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M4.694,36.193V32.676L.418,30.138Z",
    transform: "translate(0 -21.526)",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M16.358,24.363l4.276-2.54L16.358,19.87Z",
    transform: "translate(-11.663 -14.026)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M.418,21.823l4.276,2.54V19.87Z",
    transform: "translate(0 -14.026)",
    fill: "#191919"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthBlack);
export default __webpack_public_path__ + "static/media/eth-black.e8e50a03d40645eb13eb0cb62c04e4d8.svg";
export { ForwardRef as ReactComponent };